import { getSpreadHeightFromSpread } from "editor/src/store/design/selector/getSpreadHeight";
import getSpreadWidthFromSpread from "editor/src/store/design/selector/getSpreadWidthFromSpread";
import {
  Spread,
  SpreadGroundImage,
  SpreadGroup,
} from "editor/src/store/design/types";

import findSpreadGroundImage from "./findSpreadGroundImage";

const getGroupedSpreadInfo = (
  spreadGroup: SpreadGroup,
  spreads: Spread[],
  spreadBackgrounds?: SpreadGroundImage[],
  spreadForegrounds?: SpreadGroundImage[],
) =>
  spreadGroup.spreadIndexes.map((groupedSpreadIndex, index) => {
    const groupSpread = spreads[groupedSpreadIndex];
    const spreadWidth = getSpreadWidthFromSpread(groupSpread);
    const spreadHeight = getSpreadHeightFromSpread(groupSpread);

    // preview dimensions used for calculating the groupedSpreadOffsets
    const previewWidth =
      spreadGroup.position === "horizontal" ? spreadWidth : 0;
    const previewHeight =
      spreadGroup.position === "vertical" ? spreadHeight : 0;

    return {
      // used to offset the pages to make them appropriate to the spread grouping.
      spreadOffsetCoords: {
        left: (spreadGroup.spreadIndexes.length - 1 - index) * previewWidth,
        top: (spreadGroup.spreadIndexes.length - 1 - index) * previewHeight,
      },
      // GAPI-30848 — tech-suffix-insensitive lookup. See
      // `findSpreadGroundImage` comment.
      backgroundImage: findSpreadGroundImage(
        spreadBackgrounds,
        groupSpread?.name,
      ),
      foregroundImage: findSpreadGroundImage(
        spreadForegrounds,
        groupSpread?.name,
      ),
      groupSpread,
      spreadWidth,
      spreadHeight,
    };
  });

export default getGroupedSpreadInfo;
